import { all, takeLatest } from 'redux-saga/effects';
import { USER_SAVE_DOCUMENTS_FORM } from '../../redux/user/types';

import saveDoc from './saveDoc';

export default function*() {
    yield all([takeLatest(USER_SAVE_DOCUMENTS_FORM, saveDoc)]);
}
